const DEFAULT_TIMEZONE = 'Europe/Warsaw';

const chartOptions: Highcharts.ChartOptions = {
  type: 'area',
  plotBackgroundColor: {
    linearGradient: { x1: 0.5, y1: 0, x2: 0.5, y2: 1 },
    stops: [
      [0, 'rgb(255, 255, 255)'],
      [1, 'rgba(67, 121, 238, 0.16)']
    ]
  },
  plotBorderWidth: 0,
};

export const seriesOptionsConfigurationBase: Highcharts.SeriesAreaOptions = {
  type: 'area',
  fillColor: '#fff',
  pointPlacement: 'on',
  showInNavigator: true
};

export const highchartsOptionsConfigurationBase: Highcharts.Options = {
  accessibility: {
    enabled: false
  },
  chart: chartOptions,
  credits: {
    enabled: false
  },
  time: {
    timezone: DEFAULT_TIMEZONE
  },
  title: {
    text: undefined
  },
  yAxis: {
    title: {
      text: null
    }
  }
};